import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// Photos uploaded to the app are served by the API; others are full addresses
export const shopImageUrl = (url) =>
  (url && url.startsWith('/') ? `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}${url}` : url);

export const shopApi = {
  getProducts: () =>
    axios.get(`${API_URL}/booking/shop/products`, { headers: getHeaders() }),

  createOrder: (items) =>
    axios.post(`${API_URL}/booking/shop/orders`, { items }, { headers: getHeaders() }),

  getOrder: (orderId) =>
    axios.get(`${API_URL}/booking/shop/orders/${orderId}`, { headers: getHeaders() }),

  getMyOrders: () =>
    axios.get(`${API_URL}/booking/shop/my-orders`, { headers: getHeaders() }),

  // Admin: the club's products
  getAdminProducts: () =>
    axios.get(`${API_URL}/booking/shop/admin/products`, { headers: getHeaders() }),
  createProduct: (product) =>
    axios.post(`${API_URL}/booking/shop/admin/products`, product, { headers: getHeaders() }),
  saveProduct: (id, product) =>
    axios.put(`${API_URL}/booking/shop/admin/products/${id}`, product, { headers: getHeaders() }),
  reorderProducts: (ids) =>
    axios.put(`${API_URL}/booking/shop/admin/products`, { ids }, { headers: getHeaders() }),
  deleteProduct: (id) =>
    axios.delete(`${API_URL}/booking/shop/admin/products/${id}`, { headers: getHeaders() }),
  uploadProductPhoto: (id, file, { sizeGuide = false } = {}) => {
    const form = new FormData();
    form.append('photo', file);
    return axios.post(`${API_URL}/booking/shop/admin/products/${id}/photos${sizeGuide ? '?sizeGuide=1' : ''}`, form, { headers: getHeaders() });
  },

  // Admin
  getAdminOrders: (status = 'ALL') =>
    axios.get(`${API_URL}/booking/shop/admin/orders`, { params: { status }, headers: getHeaders() }),

  updateOrderItem: (orderId, itemId, payload) =>
    axios.patch(`${API_URL}/booking/shop/admin/orders/${orderId}/items/${itemId}`, payload, { headers: getHeaders() }),

  archiveOrder: (orderId, note) =>
    axios.post(`${API_URL}/booking/shop/admin/orders/${orderId}/archive`, { note }, { headers: getHeaders() }),

  restoreOrder: (orderId) =>
    axios.post(`${API_URL}/booking/shop/admin/orders/${orderId}/restore`, {}, { headers: getHeaders() }),

  getPendingOrderCount: () =>
    axios.get(`${API_URL}/booking/shop/admin/orders/pending-count`, { headers: getHeaders() }),
};
